<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="getStepLastStatus(step) ? on : {}"
      >
        <v-stepper-step
          :class="{'pointer': statusChangePermitted}"
          :step="step"
          :complete="project.progressState.state > step || project.progressState.state=== maxStepNumber"
          :color="progressColor"
          @click="statusChangePermitted && showChangeStatusDialog()"
        />
      </span>
    </template>
    {{ getStepLastStatus(step) }}
  </v-tooltip>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props:{
    step: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      maxStepNumber: 8
    }
  },
  computed: {
    ...mapState('project', [
      'project',
    ]),
    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),
    statusChangePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
    progressColor() {
      if (this.project.progressState.dismissed) return '#E25B46';
      if (this.project.progressState.state >= this.maxStepNumber) return '#00695F';
      return 'primary';
    },
  },
  methods: {
    ...mapActions('dialog', [
      'showDialog',
    ]),
    getStepLastStatus(step) {
      return this.project?.lastStatusPerStep?.find(status => status.lastNumber === Number(step))?.last
    },
    showChangeStatusDialog() {
      this.showDialog({
        header: 'Status projektu',
        text: 'Wybierz i zmień ręcznie status projektu',
        component: 'ProjectStatus',
        props: {
          id: this.project.id,
          step: this.step
        },
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
